// extracted by mini-css-extract-plugin
var _1 = "fONeVORObcWTeZ1eMZqi";
export { _1 as "snackbarButton" }
